import { defineComponent } from 'vue'

import { Location } from '@skinsoft/types'
import { locationSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export const LocationName = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['id'],
    template: require('./location-name.html'),
    data() {
        return {
            location: null as any as Location,
        }
    },
    computed: {
        value(): ReturnType<typeof locationSelectors.translatedTitle> {
            return locationSelectors.translatedTitle(this.location, this.getAppLocale());
        },
    },
    methods: {
        subscribeToLocation() {
            this.subscribeTo(
                this.$locationDataStore.fetchOne(this.id),
                location => {
                    this.location = location;
                },
                'location',
            );
        },
    },
    watch: {
        id: {
            handler(id: string) {
                this.unsubscribeFrom('location');
                if (id) {
                    this.subscribeToLocation();
                }
            },
            immediate: true,
        },
    },
})
